import { type FunctionComponent, useCallback, useState } from 'react';
import SelectPayment from "@payment/SelectPayment";
import { payments0 } from "@/data/PaymentHub.ts";
import { PaymentType } from "@/data/Payment.ts";
import {
  blockMutateOrderButton,
  isActivePaymentId,
  multiPayment0,
  onPaymentClick, order0, scopeOrder0
} from "@/react/PaymentView/PaymentView.tsx";
import AutoIntergratingPopup from '@payment/AutoIntergratingPopup.tsx';
import PortalPopup from "@/react/core/PortalPopup.tsx";
import { clsx } from "clsx";
import _ from "lodash";
import { toast } from "react-toastify";
import { LL0 } from '@/react/core/I18nService';
import { userFLow } from "@/shared/logger.ts";
import { loginUser } from "@/data/UserSignal.ts";

const PaymentSelectItems: FunctionComponent = () => {
  const [isAutoIntergratingPopupOpen, setAutoIntergratingPopupOpen] =
    useState(false);

  const openAutoIntergratingPopup = useCallback(() => {
    setAutoIntergratingPopupOpen(true);
  }, []);

  const closeAutoIntergratingPopup = useCallback(() => {
    setAutoIntergratingPopupOpen(false);
  }, []);

  return (
    <>
      <div
        className={clsx(
          "self-stretch gap-[8px] min-w-[240px] grid grid-cols-[repeat(2,1fr)] [grid-row-gap:8px] [grid-column-gap:8px] text-left text-lg text-white-solid-white-100-ffffff font-mulish height_414:w-auto height_414:h-auto height_414:grid height_414:grid-cols-[repeat(2,1fr)] height_414:[grid-row-gap:8px] height_414:[grid-column-gap:8px]",
          {
            'opacity-70': blockMutateOrderButton()
          }
        )}
      >        {payments0().map((payment, index) =>
        <SelectPayment
          icon={payment.icon}
          paymentMethod={payment.name}
          isSelected={isActivePaymentId(payment.name!)}
          onClick={async() => {
            userFLow(`Select payment ${payment.name!} in Payment`, {
              username: loginUser()?.name,
              orderId: order0?.()._id
            })
            //handle case not choose seat
            const notPay = scopeOrder0()?.items?.length === 0;
            if (notPay) {
              userFLow(`Select payment ${payment.name!} for no seat`, {
                username: loginUser()?.name,
                orderId: order0?.()._id
              })
            }
            if (!notPay) {
              if (multiPayment0()) {
                if (payment.type === PaymentType.Debitor ||_.lowerCase(payment.name).includes('debitor')) {
                  toast(`${LL0().payment.unsupportDebitor()}`, {type: 'info', autoClose: 500})
                  return
                }
              }
              await onPaymentClick(payment)
            }
          }}
          key={index}
        />
      )}
      </div>
      {isAutoIntergratingPopupOpen && (
        <PortalPopup
          overlayColor="rgba(0, 0, 0, 0.2)"
          placement="Centered"
          onOutsideClick={closeAutoIntergratingPopup}
        >
          <AutoIntergratingPopup onClose={closeAutoIntergratingPopup} />
        </PortalPopup>
      )}
    </>
  );
};

export default PaymentSelectItems;